import axios from 'axios';

import * as actionTypes from './actionTypes';
import {authEndpoint, getCurrentTimezone} from '../utility';

import Alert from 'react-s-alert';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authProfileLoad = (token, userId) => {
    return dispatch => {
        // load state information
        let url = authEndpoint + 'api/v1/rest-auth/user/';
        axios.get(url, {
            headers: {'Authorization': 'Token '+ token}
        })
            .then(function (response) {
                let calendarId = response.data.calendar_id;
                let hasSchedule = response.data.has_schedule;
                let firstName = response.data.first_name;
                let lastName = response.data.last_name;
                let emailVerified = response.data.email_verified;
                localStorage.setItem('calendarId', calendarId);
                localStorage.setItem('firstName', firstName);
                localStorage.setItem('lastName', lastName);
                localStorage.setItem('hasSchedule', hasSchedule);
                
                if (emailVerified===false) {
                    Alert.info("To unlock the advance features, please check your email and verify your email address");
                }

                dispatch(authSuccess(token, userId, calendarId, firstName, lastName, hasSchedule));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const authSuccess = (token, userId, calendarId, firstName, lastName, hasSchedule) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId,
        calendarId: calendarId,
        firstName: firstName,
        lastName: lastName,
        hasSchedule: hasSchedule
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    localStorage.removeItem('calendarId');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime);
    };
};

export const auth = (email, password, isSignup, passwordConfirm=null, firstName=null, lastName=null) => {
    return dispatch => {
        dispatch(authStart());
        let url;
        let authData;
        if (isSignup===true) {
            url = authEndpoint + 'api/v1/rest-auth/registration/';
            authData = {
                email: email,
                password1: password,
                password2: passwordConfirm,
                first_name: firstName,
                last_name: lastName,
                timezone: getCurrentTimezone(),
            };
        }
        else {
            url = authEndpoint + 'api/v1/rest-auth/login/';
            authData = {
                email: email,
                password: password,
            };
        }

        axios.post(url, authData)
            .then(response => {
                let dayExpire = 30;
                let milliSecondExpire = dayExpire * 24 * 60 * 60 * 1000;
                let expirationDate = new Date(new Date().getTime() + milliSecondExpire);
                localStorage.setItem('token', response.data.key);
                localStorage.setItem('expirationDate', expirationDate);
                localStorage.setItem('userId', email);
                dispatch(authProfileLoad(response.data.key, email));
                // dispatch(checkAuthTimeout(milliSecondExpire));
            })
            .catch(err => {
                console.log(err.response.data);
                if (err.response.data.error.length > 0) {
                    for (const index in err.response.data.error[0]) {
                        Alert.error(index + ": " + err.response.data.error[0][index][0].message);
                    }
                }
                dispatch(authFail(err.response.data.error[0]));
            });
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        const calendarId = localStorage.getItem('calendarId');
        const firstName = localStorage.getItem('firstName');
        const lastName = localStorage.getItem('lastName');
        const hasSchedule = localStorage.getItem('hasSchedule') === "true";
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {
                const userId = localStorage.getItem('userId');
                dispatch(authSuccess(token, userId, calendarId, firstName, lastName, hasSchedule));
                // dispatch(checkAuthTimeout( ( expirationDate.getTime() - new Date().getTime()) ) * 1000);
            }   
        }
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/auth.js